import React from "react";
import { Flag, Users } from "lucide-react";
import { GrAnnounce } from "react-icons/gr";
import { MdGroups } from "react-icons/md";

const ChatHeader = ({
    activeGlobalChat,
    currentSnag,
    isOwnerOrAdmin,
    setSelectedMemberIds,
    setInitialMemberIds,
    snagMembers,
    setShowMemberModal,
}) => {
    if (activeGlobalChat === "general-updates") {
        return (
            <div className="p-3 border-b bg-white flex flex-col">
                <div className="flex items-center">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center shadow-sm">
                        <GrAnnounce className="w-5 h-5 text-purple-900" />
                    </div>
                    <h2 className="font-bold text-gray-800">General Updates</h2>
                </div>
                <div className="flex items-center mt-1 text-xs text-gray-500">
                    <span className="mr-2">All</span>
                    <span>•</span>
                    <MdGroups className="w-4 h-4 ml-2" />
                </div>
            </div>
        );
    }

    if (currentSnag) {
        return (
            <div className="border-b bg-white">
                {/* Main header */}
                <div className="px-4 py-2 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center shadow-sm">
                            <Flag className="w-5 h-5 text-purple-700" />
                        </div>
                        <div>
                            <h2 className="font-bold text-gray-900 text-lg">
                                {currentSnag.title}
                            </h2>
                            <div className="flex items-center gap-2 text-xs text-gray-500 mt-0.5">
                                <span>Created by {currentSnag.creatorName}</span>
                                <span>•</span>
                                <span>
                                    {new Date(currentSnag.createdAt).toLocaleDateString()}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        {isOwnerOrAdmin && (
                            <button
                                onClick={() => {
                                    const current = snagMembers[currentSnag.id] ?? [];
                                    setSelectedMemberIds(current);
                                    setInitialMemberIds?.(current);
                                    setShowMemberModal(currentSnag.id);
                                }}
                                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-purple-700 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors"
                            >
                                <Users size={16} />
                                <span>
                                    {snagMembers[currentSnag.id]?.length ? "Edit" : "Add"} Members
                                </span>
                            </button>
                        )}
                    </div>
                </div>

                {/* Members info bar */}
                <div className="px-4 py-2 bg-gray-50 border-t border-gray-100 flex items-center gap-2">
                    <MdGroups className="w-4 h-4 text-gray-600" />
                    <span className="text-sm text-gray-700 font-medium">
                        {snagMembers[currentSnag.id]?.length
                            ? `${snagMembers[currentSnag.id].length} member${snagMembers[currentSnag.id].length !== 1 ? "s" : ""
                            }`
                            : "Open to all team members"}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 text-center text-gray-500 bg-white border-b">
            Select a chatroom or General Updates to start chatting
        </div>
    );
};

export default ChatHeader;
